'use strict'

hostCom.send('awe:ping')
// this code runs only once, and can be discarded afterwards.
// That should be the case after the initWidget event has been processed.
void function (){

  // fetches template and inits Vue app
  async function start(e){
    e.params.perf.switch = Date.now() - e.switchStart
    performance.mark('app-start')

    try{
      // check again safeframe for media widgets when not detected
      if (e.params.media && !e.params.withSafeFrame)
        detectSafeFrame()

      const defaultTemplates = ['swnDefault', 'lp-legacy']
      // get template
      // set operator to special value if default template is selected - which isn't linked to a specific operator
      const operator = defaultTemplates.includes(e.params.template) || /^(default)?_/.test(e.params.template) ? 'default' : e.wtbConf.operatorId,
            templateName = e.params.template,
            tmplPath = `${operator}/${templateName}`

      performance.mark('template-start')
      const res = await fetch(`../../../templates/${tmplPath}/template.html`)
      performance.measure('template', 'template-start')

      let hostStyle = '',
          scripts = [], // urls for template scripts
          parameters = e.params

      if (parameters.fileProtocol)
        hostCom.allowLaxTarget()

      if (res.status != 200){
        throw new Error(`template not found at /templates/${tmplPath}/template.html`)
      }

      // get template as text & do some manipulations: extract scripts, stylesheets and parameters.
      // remove scripts from template and add them dynamically (vue doesn't parse script tags in template)

      // First, remove plugin scripts, as they must run before app instanciation.
      let template = (await res.text()).replace(/<script\s*mixin>((\s|.)*?)<\/script>/g, (match, content) => {
          insertScript(content, null)
          return ''
      })

      // once we've defined the necessary plugins, instanciate the app.
      window.app = new Vue(appDefinition)

      // remove external scripts
      template = template.replace(/<script src="(.*?)"(?:\s+integrity="(.*?)"\s*)?><\/script>/g, (match, url, integrityHash) => {
        scripts.push({type: 'url', value: url, integrity: integrityHash})
        return ''
      })
      // remove inline scripts
      .replace(/<script\s*(before-mount)?>((\s|.)*?)<\/script>/g, (match, attribute, content) => {
        // scripts tagged with before-mount are immediately inserted
        if (attribute)
          insertScript(content, null)
        else
          scripts.push({type: 'inline', value: content})
        return ''
      })
      // look for container style element and extract it
      .replace(/<host-style>((\s|.)*?)<\/host-style>/, (match, style) => {
        hostStyle = style.trim()
        return ''
      })
      // look for inline style tags and extract them.
      .replace(/<style>((\s|.)*?)<\/style>/g , (match, style) => {
        const nd = document.createElement('style')
        nd.innerHTML = style
        document.head.appendChild(nd)
        return ''
      })
      // look for container custom style element and extract it
      .replace(/<style-mapping>((\s|.)*?)<\/style-mapping>/, (match, style) => {
        let legacyCustomStyle = {}
        let legacyCustomStyleValues = {}

        const customStyleMapping = {}

        const customPropParser = /([\w-\d]+) *: *(--[\w\d-_]+\b)(?: (.+))?$/
        style.trim().split('\n').forEach(line => {
          // check if line matches the custom property mapping
          const customPropMatch = line.match(customPropParser)
          if (customPropMatch){
            const optName = customPropMatch[1],
                  customProp = customPropMatch[2],
                  ctnr = customPropMatch[3]
            customStyleMapping[optName] = [customProp, ctnr]
          }
          else{
            // line uses the legacy mapping
            const [style, selectors] = line.split(/:(.+)/)
            if (!selectors) return

            const [propName, cssProp] = style.trim().split('/') // separate property name from the actual css property it impacts
            legacyCustomStyle[propName] = selectors.trim()
            legacyCustomStyleValues[propName] = cssProp || ''
          }
        })

        app.legacyCustomStyle = legacyCustomStyle
        app.legacyCustomStyleValues = legacyCustomStyleValues
        app.customStyleMapping = customStyleMapping
        return ''
      })
      // parameters tag contains additional configuration options. if provided, they overwrite any value provided by the loader.
      .replace(/<parameters ([^>]+)><\/parameters>/, (match, attrs) => {
          attrs.match(/[\w-]+="[^"]*"/gi).forEach(attribute => {
          let name, val
          [name, val] = attribute.split('=')
          name = Utils.toCamelCase(name)
          val = val.substring(1, val.length - 1) // remove the surrounding quotes

          // assignment is done differently, depending on expected type
          switch(name){
            case 'hideHostScroll':
            case 'hasPrices':
            case 'customTrackingOldNaming':
            case 'productPagination':
              parameters[name] = val.toLowerCase() === 'true'
              break
            case 'freeSize':
            case 'fixedSize':
              parameters.freeSize = true // the attribute being present means it's true, no value needed
              break
            case 'delayGeolocation':
              parameters.delayGeolocation = true // the attribute being present means it's true, no value needed
              break
            default: // default: value is a string, taken as-is
              parameters[name] = val.trim()
          }
        })
        return ''
      })

      if (parameters.debug)
        template += '<awe-logger ref="logger"></awe-logger>'

      // finds which components are needed and load them.
      const components = findComponents(template)
      const p = loadComponents(components)

      // send style to host, even if not defined. This message is used as a signal to show widget and custom buttons.
      // IE does not apply styles if the string is not cleaned (no newlines, no multiple spaces)
      hostCom.send('awe:host-style', { style: hostStyle.replace(/\s+/g, ' ') })

      // insert template & mount app
      let appNd = document.getElementById('app-ctnr')

      // wait for component scripts to load before mounting app.
      // insert template in DOM after the wait. Otherwise we see the ugly raw template for the duration of components load time.
      await p

      appNd.innerHTML = template
      performance.mark('vue-mount-start')
      app.$mount(appNd)
      performance.measure('vue-mount', 'vue-mount-start')
      parameters.perf.mount = performance.getEntriesByName('vue-mount', 'measure')[0].duration
      parameters.perf.template = performance.getEntriesByName('template', 'measure')[0].duration

      // wait for app to mount before loading additional template scripts
      for (let i = 0; i < scripts.length; i++){
        switch(scripts[i].type){
          case 'url':
            insertScript(null, scripts[i].value, scripts[i].integrity)
            break
          case 'inline':
            insertScript(scripts[i].value, null)
            break
        }
      }

      parameters.templatePath = tmplPath
      app.init(parameters, e.wtbConf)

      const buildNd = document.querySelector('meta[name="build"]')
      if (buildNd)
        hostCom.send('awe:templateBuild', {name: templateName, build: buildNd.getAttribute('content')})
    }
    catch(err){
      console.error(err)
    }
  }

  // inserts script node, setting either the content or the src attribute
  function insertScript(content, src, integrity){
    const nd = document.createElement('script')
    if (content)
      nd.innerHTML = content
    else if (src){
      nd.src = src
      if (integrity)
        nd.setAttribute('integrity', integrity)
    }
    document.head.appendChild(nd)
  }

  // returns list of components
  function findComponents(template){
    const components = ['@@LAZY_COMPONENTS']

    let found = []
    for (let i  = 0; i < components.length; i++){
      let compName = components[i].n
      if (template.includes('awe-' + compName)){
        if (components[i].d){
          // include dependencies
          components[i].d.forEach(dep => {
            const depDef = components.find(x => x.n === dep)
            if (depDef)
              found.push(depDef)
          })
        }
        found.push(components[i])
      }
    }
    return found
  }

  // load component scripts
  function loadComponents(comps){
    let proms = []
    for (let i = 0; i < comps.length; i++){
      const compName = comps[i].n,
            hash = comps[i].h,
            nd = document.createElement('script')
      nd.src = `components/${compName}/${compName}.js`

      if (hash)
        nd.setAttribute('integrity', 'sha384-' + hash)

      proms.push(new Promise(resolve => {
        nd.onload = resolve
      }))
      document.head.appendChild(nd)
    }
    return Promise.all(proms)
  }

  // sends a message to loader and waits for a response.
  // if no response, we assume postmessage was blocked and safeFrame is enabled.
  function detectSafeFrame(){
    let timeoutId
    const sfDetect = e => {
      clearTimeout(timeoutId)
    }
    hostCom.send('awe:sfDetect', {}, sfDetect)
    timeoutId = setTimeout(() => {
      if (app.initDone)
        app.setSafeFrame()
      hostCom.off('awe:sfDetect', sfDetect)
    }, 2e3)
  }

  // start init when loader sends widget parameters after widget is loaded
  hostCom.one('awe:initWidget', start)
}()
